export const UPDATE_WIDGET = 'UPDATE_WIDGET';
export const UPDATE_CLOCK = 'UPDATE_CLOCK';
export const UPDATE_FEED = 'UPDATE_FEED';
export const UPDATE_STATE = 'UPDATE_STATE';
export const CLEAR_CLOCK_TIMER = 'CLEAR_CLOCK_TIMER';
export const DELETE_FEED = 'DELETE_FEED';
export const DELETE_STATE = 'DELETE_STATE';
export const PUSH_TO_ARRAY = 'PUSH_TO_ARRAY';
